import * as angular from "angular";
import {IController} from "angular";
import {AccountRequests} from "../../services/account-requests.service";
import {AccountsAlerts} from "../../services/accounts-alerts.service";
import {AccountDialogService} from "../../services/account-dialogs-service.service";
import {AccountsService} from "../../services/accounts-service.service";
import {$agentsFactory} from "../../../agents/$agents.factory";
import {AccountModel} from "../../angular/models/account.model";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class SupplyAccountsCtrl implements IController {

  accountTypes: string[];

  private agentsRef: any;

  private selectedAccount: any;
  private queryString: string;
  private type: any;
  private doReload: boolean;

  constructor(private $state, private $log, private confirmDialogService: ConfirmDialogService, private accountRequests: AccountRequests,
              private accountDialogService: AccountDialogService, private accountsAlerts: AccountsAlerts, private $agents: $agentsFactory,
              private bringozLoaderService: BringozLoaderService, private accountsService: AccountsService) {
  }

  $onInit() {
    this.agentsRef = this.$agents();
    this.selectedAccount = null;
    this.queryString = null;
    this.type = this.accountTypes[0];
    this.doReload = false;
  }

  changeAccountType(type) {
    this.type = type;
  }

  onQueryChange(queryString) {
    this.queryString = queryString;
  }

  createAccount(event) {
    this.accountDialogService.createNewCarrier(event, this.accountTypes, this.type)
      .then((carrier) => {
        this._onCreateNewCarrier(carrier);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onAccountSelection(account: AccountModel) {
    this.selectedAccount = account;
  }

  onDeleteAccount(account, $event) {
    let loading = false;
    const text = 'Are you sure you want to delete this account?';
    this.confirmDialogService.confirmMask('Delete Account', text, $event)
      .then((shouldMask) => {
        loading = true;
        this.bringozLoaderService.on();
        return this.accountRequests.deleteAccount(account.id, shouldMask);
      })
      .then((response) => {
        this.accountsAlerts.supplyDeleteOneSuccess(account);
        this.doReload = true;
      })
      .catch((error) => {
        if (error) {
          this.accountsAlerts.supplyDeleteOneError();
          this.$log.error('Failed to delete account @agentsListView@onDeleteAgent', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        if (loading) {
          this.bringozLoaderService.off();
        }
      })
  }

  onReloadAccountsDone() {
    this.doReload = false;
  }

  private _onCreateNewCarrier(carrier) {
    this.accountsService.createOne(carrier)
      .then(() => {
        this.doReload = true;
      });
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('supplyAccounts', {
    bindings: {
      accountTypes: '<'
    },
    template: require('./supply-accounts.html').default,
    controller: SupplyAccountsCtrl
  });
